import { render, staticRenderFns } from "./VideoJs.vue?vue&type=template&id=6cbf2025&scoped=true&"
import script from "./VideoJs.vue?vue&type=script&lang=js&"
export * from "./VideoJs.vue?vue&type=script&lang=js&"
import style0 from "./VideoJs.vue?vue&type=style&index=0&id=6cbf2025&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf2025",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VSpacer,VToolbar})
